<p>list-attendance works!</p>
